export default __webpack_public_path__ + "static/media/logoCollapsed.d7ab26ec.svg";